import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import { parseLabeledLines } from '../../lib/parseLabeledLines';
import type { BlockRenderProps } from '../../types';

export function LiveBakeryCounterList({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const itemsRaw = pickBlockField(block.content, 'items', locale);
  const items = parseLabeledLines(itemsRaw);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-bakery-counter', isActive ? 'ws-block--active' : '']
        .filter(Boolean)
        .join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="bakery"
    >
      <div className="ws-bakery-counter__inner">
        <EditableContent
          as="h2"
          fieldKey="sectionTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-bakery-counter__title"
        >
          {sectionTitle}
        </EditableContent>
        {supporting || editable ? (
          <EditableContent
            fieldKey="supporting"
            editable={editable}
            activeEditTarget={target}
            className="ws-bakery-counter__supporting"
          >
            {supporting}
          </EditableContent>
        ) : null}
        {editable ? (
          <EditableContent
            fieldKey="items"
            editable={editable}
            activeEditTarget={target}
            className="ws-bakery-counter__editor"
          >
            {itemsRaw}
          </EditableContent>
        ) : (
          <ul className="ws-bakery-counter__list">
            {items.map((item, index) => {
              const soldOut = /ausverkauft|sold\s*out|hết/i.test(item.meta);
              const fresh = /frisch|fresh|còn|mới/i.test(item.meta);
              const status = soldOut ? 'sold-out' : fresh ? 'fresh' : 'limited';
              return (
                <li
                  key={`${item.label}-${index}`}
                  className={[
                    'ws-bakery-counter__item',
                    soldOut ? 'ws-bakery-counter__item--sold-out' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  data-status={status}
                >
                  <span className="ws-bakery-counter__name">{item.label}</span>
                  {item.meta ? (
                    <span className="ws-bakery-counter__status">{item.meta}</span>
                  ) : null}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </section>
  );
}
